export default {
  init() {
    // JavaScript to be fired on the about us page
    jQuery('.single-post .main-content').addClass('show');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js